(function(){
  var eeoHostType=(function(){
    var locationHost=window.location.host;
    var data={
      isEEOLOCAL: (locationHost.indexOf('local')===0),
      isEEO13:    (locationHost.indexOf('www13.eeo.im')===0),
      isEEO35:    (locationHost.indexOf('www.dev35.eeo.im')===0 || locationHost.indexOf('www35.eeo.im')===0),
      isEEOIM:    (locationHost.indexOf('www.eeo.im')===0),
      isEEOCN:    (locationHost.indexOf('www.eeo.cn')===0),
      isEEO11:    (locationHost.indexOf('www11.eeo.im')===0),
      isEEOKOOCOM:(locationHost.indexOf('www.eeokoo.com')===0),
    }
    data.isEEOTEST=(data.isEEOLOCAL || data.isEEO13 || data.isEEO35 || data.isEEOIM);
    data.isEEOKOOTEST=data.isEEO11;
    
    data.isEEO=(data.isEEOTEST || data.isEEOCN);
    data.isEEOKOO=(data.isEEOKOOTEST || data.isEEOKOOCOM);
    return data;
  })()
  var eeoConfig= {
  };
  Vue.prototype.eeoHostType=eeoHostType;
  switch(window.location.hostname){
    case 'www13.eeo.im':
      break;
    default:
      break;
  }
  Vue.prototype.EEO_CONFIG=eeoConfig;
})();